import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-illustrative/lamp.svg';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import pickBy from 'lodash/pickBy';
import isNil from 'lodash/isNil';
import defer from 'lodash/defer';
import shallowEqualObjects from 'shallow-equal/objects';
import registerStoreModule from '~/helpers/store-helper';
import pageActions from '~/store/modules/pageActions';
import search from '~/store/modules/search';
import { extractCategoryFilterByFromQuery, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, extractCategoryQueryFromFilterBy, extractSelectedFilters } from '~/helpers/extract-helper';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import SearchSeo from '~/components/functional/Seo/SearchSeo.vue';
import CategoryTcVars from '~/components/functional/TcVars/CategoryTcVars.vue';
import CategoryLoading from '~/components/templates/Category/CategoryLoading.vue';
import CategoryTemplate from '~/components/templates/Category/CategoryTemplate.vue';
import Empty from '~/components/specific/Blocks/Empty.vue';
import { componentList, typeDefinition, buildSlices } from '~/helpers/editorial-helper';
import { fetchContent } from '~/services/editorial';
var components = {};
componentList().forEach(function (e) {
  components[e.type || e.name] = function (slug) {
    return {
      component: import("~/components/organisms/Editorial/".concat(slug))
    };
  };
});
export default {
  components: {
    MdmBreadcrumb: MdmBreadcrumb,
    SearchSeo: SearchSeo,
    CategoryTcVars: CategoryTcVars,
    CategoryLoading: CategoryLoading,
    CategoryTemplate: CategoryTemplate,
    Empty: Empty
  },
  httpHeaders: function httpHeaders() {
    return {
      'Cache-Control': 'max-age=0, s-maxage=86400, public'
    };
  },
  asyncData: function () {
    var _asyncData = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref3) {
      var apolloProvider, store, definition, _ref4, _ref4$results, _ref4$results$, id, data, slices;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              apolloProvider = _ref3.app.apolloProvider, store = _ref3.store;
              _context.prev = 1;
              definition = typeDefinition('noresult');
              _context.next = 5;
              return fetchContent(store, {
                type: 'noresult'
              });

            case 5:
              _ref4 = _context.sent;
              _ref4$results = _slicedToArray(_ref4.results, 1);
              _ref4$results$ = _ref4$results[0];
              id = _ref4$results$.id;
              data = _ref4$results$.data;
              _context.next = 12;
              return buildSlices(definition, data, apolloProvider.defaultClient, store);

            case 12:
              slices = _context.sent;
              return _context.abrupt("return", {
                type: definition.type,
                template: {
                  path: definition.path,
                  data: data
                },
                id: id,
                slices: slices
              });

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);

            case 19:
              return _context.abrupt("return", false);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16]]);
    }));

    function asyncData(_x) {
      return _asyncData.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      loadingProducts: true,
      loadingNextPage: false,
      loadingPreviousPage: false,
      unwatchSearchQuery: null,
      unwatchNextPage: null,
      unwatchPreviousPage: null
    };
  },
  computed: _objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    description: 'search/description',
    products: 'search/products',
    productsCount: 'search/productsCount',
    filterBy: 'pageActions/filterBy',
    orderBy: 'pageActions/orderBy',
    sortBy: 'pageActions/sortBy',
    previousPage: 'pageActions/previousPage',
    nextPage: 'pageActions/nextPage'
  }), {
    categoryQuery: function categoryQuery() {
      return _objectSpread({}, extractCategoryQueryFromFilterBy(this.filterBy), {
        sort: this.sortBy,
        order: this.orderBy
      });
    },
    selectedFilters: function selectedFilters() {
      return extractSelectedFilters(this.filterBy, this.description.filters);
    },
    currentPath: function currentPath() {
      return "".concat(this.baseURL).concat(this.buildSearchUrl(this.locale, this.description.query));
    },
    breadcrumb: function breadcrumb() {
      var _this = this;

      var breadcrumb = this.description.breadcrumb || [];
      return breadcrumb.map(function (entry) {
        return {
          label: entry.title,
          url: "/".concat(_this.locale.market, "/").concat(_this.locale.language)
        };
      });
    },
    pageTitle: function pageTitle() {
      var _ref, _ref2;

      var replacement = {
        x: this.productsCount,
        y: (_ref2 = this.description) != null ? _ref2.query : _ref2,
        z: (_ref = this.description) != null ? _ref.suggest_query : _ref
      };
      var tradName = 'searchTitle';

      if (!this.productsCount) {
        tradName = 'searchTitleNoResults';
      } else if (this.description.is_corrected) {
        tradName = 'searchTitleCorrect';
      } else if (this.description.suggest_query) {
        tradName = 'searchTitleSuggest';
      }

      return this.$i18n.tc(tradName, this.productsCount, replacement);
    },
    speedcurveConfig: function speedcurveConfig() {
      var luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "search";'
      };
      return luxConfig;
    },
    isSearchQueryAlgolia: function isSearchQueryAlgolia() {
      return this.$route.query.query;
    }
  }),
  created: function created() {
    var _this2 = this;

    if (this.template && this.template.path) {
      this[this.type] = function () {
        return components[_this2.type](_this2.template.path);
      };
    }

    if (this.slices) {
      this.slices.forEach(function (_ref5) {
        var type = _ref5.type,
            path = _ref5.path;

        _this2[type] = function () {
          return components[type](path);
        };
      });
    }

    registerStoreModule(this.$store, 'search/', search);
    registerStoreModule(this.$store, 'pageActions/', pageActions);

    if (process.client) {
      var _this$$route = this.$route,
          keyword = _this$$route.params.keyword,
          query = _this$$route.query;
      var args = {
        keyword: keyword,
        query: query
      };
      this.resetPagination();
      this.resetFilters();
      this.resetSearch();
      this.setDefaultFilterBy(extractCategoryFilterByFromQuery(query));
      this.setDefaultSortBy(extractCategorySortByFromQuery(query));
      this.setDefaultOrderBy(extractCategoryOrderByFromQuery(query));
      this.setPreviousPage(extractCategoryPreviousPageFromQuery(query));
      this.setNextPage(extractCategoryNextPageFromQuery(query));

      try {
        this.fetchSearch(args).then(function () {
          _this2.loadingProducts = false;

          _this2.scrollBackToProduct(localStorage.getItem('currentProduct'));

          localStorage.removeItem('currentProduct');
        });
      } catch (error) {
        this.$logger.error(error);
      }
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5() {
      var _this3 = this;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              this.unwatchSearchQuery = this.$watch('categoryQuery',
              /*#__PURE__*/
              function () {
                var _ref6 = _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee2(oldVal, newVal) {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (shallowEqualObjects(oldVal, newVal)) {
                            _context2.next = 6;
                            break;
                          }

                          _this3.loadingProducts = true;
                          _context2.next = 4;
                          return _this3.handleWatcher(_this3.fetchSearch, 1);

                        case 4:
                          _this3.resetPagination();

                          _this3.loadingProducts = false;

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x2, _x3) {
                  return _ref6.apply(this, arguments);
                };
              }());
              this.unwatchNextPage = this.$watch('nextPage',
              /*#__PURE__*/
              _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee3() {
                var predicate;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        predicate = _this3.nextPage === 1 && _this3.previousPage === 1;

                        if (predicate) {
                          _context3.next = 6;
                          break;
                        }

                        _this3.loadingNextPage = true;
                        _context3.next = 5;
                        return _this3.handleWatcher(_this3.appendProducts, _this3.nextPage);

                      case 5:
                        _this3.loadingNextPage = false;

                      case 6:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              })));
              this.unwatchPreviousPage = this.$watch('previousPage',
              /*#__PURE__*/
              _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee4() {
                var predicate;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        predicate = _this3.nextPage === 1 && _this3.previousPage === 1;

                        if (predicate) {
                          _context4.next = 6;
                          break;
                        }

                        _this3.loadingPreviousPage = true;
                        _context4.next = 5;
                        return _this3.handleWatcher(_this3.prependProducts, _this3.previousPage);

                      case 5:
                        _this3.loadingPreviousPage = false;

                      case 6:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              })));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    this.unwatchSearchQuery();
    this.unwatchNextPage();
    this.unwatchPreviousPage();
  },
  methods: _objectSpread({}, mapMutations({
    setDefaultFilterBy: 'pageActions/SET_DEFAULT_FILTERBY',
    setDefaultSortBy: 'pageActions/SET_DEFAULT_SORTBY',
    setDefaultOrderBy: 'pageActions/SET_DEFAULT_ORDERBY',
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE',
    resetPagination: 'pageActions/RESET_PAGINATION',
    resetFilters: 'pageActions/RESET_FILTERS',
    resetSearch: 'search/RESET_SEARCH'
  }), mapActions({
    fetchSearch: 'search/fetchContent',
    appendProducts: 'search/appendProducts',
    prependProducts: 'search/prependProducts'
  }), {
    handleWatcher: function () {
      var _handleWatcher = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(handler, page) {
        var keyword, query;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                keyword = this.$route.params.keyword;
                query = _objectSpread({}, this.categoryQuery, {
                  page: page
                });
                _context6.prev = 2;
                _context6.next = 5;
                return handler({
                  query: query,
                  keyword: keyword
                });

              case 5:
                this.$router.push({
                  query: pickBy(query, function (e) {
                    return !isNil(e);
                  })
                });

                if (!this.isSearchQueryAlgolia) {
                  this.$root.$emit('reset-tcvars');
                }

                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](2);
                this.$logger.error(_context6.t0);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 9]]);
      }));

      function handleWatcher(_x4, _x5) {
        return _handleWatcher.apply(this, arguments);
      }

      return handleWatcher;
    }(),
    scrollBackToProduct: function scrollBackToProduct(arg) {
      if (arg) {
        var currentProduct = JSON.parse(arg);
        defer(function () {
          var product = document.getElementById(currentProduct);

          if (product) {
            window.scrollTo({
              top: product.offsetTop
            });
          }
        });
      }
    },
    currentComponent: function currentComponent(arg) {
      return this[arg];
    }
  }),
  head: function head() {
    return {
      script: [this.speedcurveConfig]
    };
  }
};